import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonModalPlayerView component
 */
interface Props {
  bgColor: string;
}

/**
 * Pure view component for modal player skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 */
const SkeletonModalPlayerView = ({ bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="min-h-20 items-center gap-4 py-2">
      <Box
        className={`h-7 w-10 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
      <Box
        className={`h-8 w-full animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonModalPlayerView.displayName = "SkeletonModalPlayerView";

export default memo(SkeletonModalPlayerView);
